import type { RootState } from 'features/app/store/store';
import { selectIsAstSignMailDestinationClaimed } from 'features/ast-signmail/store';
import { callIdSelector, hasActiveCallId } from 'features/call/call-base/store';
import { selectIsSignMailSessionInProgress } from 'features/signmail/store/';

export type LocalSignMailStartBlockReason =
  'no-active-call' | 'ast-claimed' | 'session-in-progress';

export const localSignMailStartBlockMessage: Record<
  LocalSignMailStartBlockReason,
  string
> = {
  'no-active-call': 'Cannot start local SignMail: there is no active call.',
  'ast-claimed':
    'Cannot start local SignMail: AST SignMail destination already claimed.',
  'session-in-progress':
    'Cannot start local SignMail: SignMail session already in progress.',
};

export const getLocalSignMailStartBlockReason = (
  state: RootState
): LocalSignMailStartBlockReason | null => {
  if (!hasActiveCallId(callIdSelector(state))) {
    return 'no-active-call';
  }
  if (selectIsAstSignMailDestinationClaimed(state)) {
    return 'ast-claimed';
  }
  if (selectIsSignMailSessionInProgress(state)) {
    return 'session-in-progress';
  }
  return null;
};

export const canStartLocalSignMailSession = (state: RootState): boolean =>
  getLocalSignMailStartBlockReason(state) === null;
